module.exports = __webpack_public_path__ + "img/video-conference.a1b0cb58.svg";